import React from 'react';

const Cgu = () => {
  return <p className="cgu">En validant votre demande d’inscription, vous acceptez nos CGU consultables <a
      href="https://inscription.entreprendre-pour-apprendre.fr/mentions-legales" target={'_blank'} rel="noopener noreferrer"> ici.</a>
  </p>;
};

export default Cgu;
